module.exports = __webpack_public_path__ + "static/img/tom.f35927b0.png";